<template>
  <div
    :class="[
      { 'mb-4': !no_bottom },
      full_width ? 'w-full' : 'max-w-limit px-4',
      'm-auto',
    ]"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "v-content-wrapper",
  props: {
    no_bottom: {
      type: Boolean,
    },
    full_width: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
